module.exports = __webpack_public_path__ + "static/media/membership2025-child-new.9004cbb5.jpg";